import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiErrorDetails } from './api-error.mapper';

@Injectable({ providedIn: 'root' })
export class ApiErrorService {
  private readonly snackBar = inject(MatSnackBar);

  showError(details: ApiErrorDetails): void {
    const action = details.suggestedAction ?? 'Dismiss';
    this.snackBar.open(details.userMessage, action, {
      duration: 8000,
      panelClass: ['api-error-snackbar'],
    });
  }
}
